import { useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let subsidiaryOptions = [];

function UserSubsidiaryTableRow({ key, loginId, subsidiaries, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [subsidiaryLoaded, setSubsidiaryLoaded] = useState(false);
	const [subsidiarySelected, setSubsidiarySelected] = useState({ name: "subsidiaryKey", label: "", value: 0 });
	const [isSubmit, setIsSubmit] = useState(false);
	const today = new Date().toISOString().split("T")[0];
	const [dates, setDates ] = useState({startDate:today, endDate:""});
	
	useEffect(() => {
		setSubsidiaryValues(subsidiaries);
	}, []);

	function setSubsidiaryValues(subsidiaryObj) {
		let subsidiaryValue = {};
		subsidiaryOptions = [];
		if (subsidiaryObj && subsidiaryObj.length > 0) {
			subsidiaryObj.map((aSubsidiary, index) => {
				subsidiaryValue.label = aSubsidiary.companyName;
				subsidiaryValue.value = aSubsidiary.companyId;
				subsidiaryOptions.push(subsidiaryValue);
				if (index == 0) {
					setSubsidiarySelected({ ...subsidiarySelected, label: (aSubsidiary.companyName), value: aSubsidiary.companyId});
				}
				subsidiaryValue = {};
			});
			setSubsidiaryLoaded(true);
		}
	}
	const subsidiaryHandler = (selectedOption, action) => {
		let companyId = selectedOption ? selectedOption.value : 0;
		let companyName = selectedOption ? selectedOption.label : "";
		setSubsidiarySelected({ ...subsidiarySelected, label: (companyName), value: companyId });
	}

	const onResponseChange = (event) => {
		const { name, value } = event.target;
		if(typeof value === 'undefined'){
			value="";
		}
    	setDates({ ...dates, [name]: value });
	}

	function submitComplete() {
		setIsSubmit(false);
	}
	const validateFields = () => {
		const errors = [];
		let date1;
		let date2;
		if (!subsidiarySelected.value || subsidiarySelected.value === 0) {
			errors.push(t("error.subsidiaryReqd"));
		}

		if(!dates.startDate){
			errors.push(t("error.startdateReqd"));
		}
		
		if(dates.endDate){
			if(dates.startDate instanceof Object){
				date1 = dates.startDate.getTime();
			} else {
				date1 = new Date(dates.startDate).getTime();
			}
			if(dates.endDate instanceof Object){
				date2 = dates.endDate.getTime();
			} else {
				date2 = new Date(dates.endDate).getTime();
			}
			if (date1 > date2) {
		    	errors.push(t("error.endDateBeforeStartDate"));
		  	} 
		}
		return errors;
	};
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let errors = validateFields();
		let startDateValue = dates.startDate;
		let endDateValue = dates.endDate;
		let dateObj;
		if(dates.startDate instanceof Object){
			dateObj = dates.startDate;
		} else {
			dateObj = new Date(dates.startDate);
		}
		startDateValue = [
						  	dateObj.getFullYear(),
						  	('0' + (dateObj.getMonth() + 1)).slice(-2),
						  	('0' + dateObj.getDate()).slice(-2)
						].join('-');

		if(dates.endDate){
			if( dates.endDate instanceof Object){
				dateObj = dates.endDate;
			} else {
				dateObj = new Date(dates.endDate);
			}
			endDateValue = [
							  dateObj.getFullYear(),
							  ('0' + (dateObj.getMonth() + 1)).slice(-2),
							  ('0' + dateObj.getDate()).slice(-2)
							].join('-');
		}
		if(errors.length > 0){
			let errorText = "";
			setIsSubmit(false);
			for(let i=0; i < errors.length; i++){
				if(i > 0){
					errorText += "<br />";
				}
				errorText += errors[i];
			}
			setError(errorText);
			setIsSubmit(false);
		} else {
			let initialValues = {
				loginId: loginId,
				subsidiaryCompanyId: subsidiarySelected.value,
				startDate: dates.startDate,
				endDate: dates.endDate,
			};
			handleSubmit(1, initialValues, submitComplete);
		}
	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{subsidiaryLoaded ? <Select
					name="companyId"
					options={subsidiaryOptions}
					onChange={subsidiaryHandler}
					placeholder={""}
					value={subsidiarySelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="companyId-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input
					type="date"
					name="startDate"
					id="startDate"
					value={dates.startDate || today}
					onChange={onResponseChange}
					className="form-control rounded-pill shadow-sm px-4 "
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input
					type="date"
					name="endDate"
					id="endDate"
					value={dates.endDate}
					onChange={onResponseChange}
					className="form-control rounded-pill shadow-sm px-4 "
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(subsidiaryOptions && subsidiaryOptions.length > 0) ?
					(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
					:
					(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button>
			</td>
		</tr>
	)

}
export default UserSubsidiaryTableRow;